import styled from 'styled-components'
import { sizes } from '../../util'

export const LogoEl = styled.object`
  pointer-events: none;
  max-height: ${props => (props.primary ? '3.5rem' : '1.5rem')};
  @media (min-width: ${sizes.small}) {
    max-height: ${props => (props.primary ? (props.isInternal ? '3.5rem' : '5rem') : '1.5rem')};
  }
  @media (min-width: ${sizes.medium}) {
    max-height: ${props => (props.primary ? (props.isInternal ? '5rem' : '7rem') : '1.5rem')};
  }
`

export const LogoWrapper = styled.div`
  /* position: ${props => (props.fixed ? 'fixed' : 'absolute')};
  position: ${props => (props.sttc ? 'static' : 'absolute')}; */
  /* will-change: transform;
  z-index: ${props => (props.left ? '100' : '45')}; */
  left: ${props => (props.left ? '1.5rem' : '')};
  right: ${props => (props.right ? '1.5rem' : '')};
  /* z-index: -100; */

  button {
    border: none;
    width: 12rem;
    height: 5rem;
    position: absolute;
    /* z-index: 10000; */
    background: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    ${props =>
    props.isInternal &&
      `
      &:hover {
        cursor: pointer;
        & + * {
        opacity: 0.7;
        }
      }
    `}
  }
`
